import { Box, Stack, Typography } from "@mui/material";
import Layout from "components/ui/molecules/Layout";
import CustomInPageNavigation from "../navigations/CustomInPageNavigation";
import { useParams } from "react-router-dom";
import CustomModelProvider from "../CustomModelProvider";
import CustomBreadcrumbs from "../navigations/CustomBreadcrumbs";
import ModelInfoButton from "../components/ModelInfoButton";

const InternalRoutePage = ({ page, data, ...props }) => {
  const { title, pageTitle, Content, modelName } = {
    ...page,
    ...props,
  };

  const titleToUse = pageTitle && data ? pageTitle(data) : title;

  const layoutContentProps = page.type === "list" ? { sx: { padding: 0 } } : {};

  return (
    <>
      <Layout title variant="component">
        <Stack direction={"row"} width={1}>
          <Stack direction={"column"} width={1}>
            <CustomBreadcrumbs page={page} />
            <Typography variant="h5">{titleToUse}</Typography>
          </Stack>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <ModelInfoButton modelName={modelName} />
          </Box>
        </Stack>
      </Layout>
      <CustomInPageNavigation page={page} data={data} />
      <Layout content {...layoutContentProps}>
        <Content key={page.path} page={page} data={data} {...props} />
      </Layout>
    </>
  );
};

function getDefinitionPage(page) {
  let current = page;
  while (current && !current.modelName) {
    current = current.parentPage;
  }
  return current;
}

const CustomRoutePage = ({ page, ...props }) => {
  const params = useParams();

  const pageDefinition = getDefinitionPage(page.parentPage);

  if (pageDefinition) {
    const modelName = pageDefinition.modelName;
    return (
      <CustomModelProvider
        modelName={modelName}
        id={params[pageDefinition.keyName || "id"]}
      >
        {(data) => (
          <InternalRoutePage
            data={data}
            page={page}
            modelName={modelName}
            {...props}
          />
        )}
      </CustomModelProvider>
    );
  }

  return <InternalRoutePage page={page} {...props} />;
};

export default CustomRoutePage;
